export interface UploadFileResponse {
  success: boolean;
  importSessionId?: string;
  errors?: string[];
}

export interface ImportingItemRawData {
  lineNumber: number;
  deliveryDate: string;
  docNumber: string;
  customerName: string;
  routeName: string;
  address: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postcode: string;
  country: string;
  phone: string;
  email: string;
  earliestTime: string;
  latestTime: string;
  stopTime: string;
  deliveryInstruction: string;
  deliveryOrder: string;
  productSKU: string;
  productName: string;
  quantity: string;
  unitOfMeasure: string;
  price: string;
  taxCode: string;
  taxPercentage: string;
}

export interface ErrorData {
  rowData: ImportingItemRawData;
  errorMessages: { [key: string]: string };
}

export interface ValidationResponse {
  success: boolean;
  recordCount: number;
  errors: string[];
  errorDetails: ErrorData[];
}

export interface Address {
  fullAddress: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postcode: string;
  country: string;
  latitude: number;
  longitude: number;
}

export interface InvalidAddress {
  customerName: string;
  address: string;
  preferredAddress?: Address;
  docNumbers: string[];
}

export interface InvalidRoute {
  routeName: string;
  docNumbers: string[];
}

export interface FixedAddress {
  customerName: string;
  invalidAddress: string;
  fixedAddress: Address;
}

export interface NewRoute {
  routeName: string;
  defaultDriverId: string;
}

export interface FixAddressesRequest {
  importSessionId: string;
  fixedAddresses: FixedAddress[];
}

export interface AddRoutesRequest {
  importSessionId: string;
  newRoutes: NewRoute[];
}

export interface InviteDriversRequest {
  importSessionId: string;
  driverEmails: string[];
}

export interface AdvancedValidateResponse {
  success: boolean;
  recordCount: number;
  errors: string[];
  invalidAddresses: InvalidAddress[];
  invalidRoutes: InvalidRoute[];
}

export interface ImportResponse {
  success: boolean;
  recordsImported: number;
  errors: string[];
}

export interface Driver {
  id: string;
  givenName: string;
  lastName: string;
  email: string;
}

export interface RouteDriverSelection {
  routeName: string;
  defaultDriverId: string;
  orderCount: number;
}

export interface GetDriverListResponse {
  data: Driver[];
}

export enum ImportMethod {
  HEADERS_AND_DETAILS = "headers_and_details",
  HEADERS_ONLY = "headers_only",
}

export enum DocumentType {
  ORDER = "Order",
  INVOICE = "Invoice",
}

export enum TaxType {
  EXCLUSIVE = "exclusive",
  INCLUSIVE = "inclusive",
}

export enum AddressMode {
  SINGLE_LINE = "single_line",
  MULTI_LINE = "multi_line",
}

export interface GoogleAddressPrediction {
  description: string;
  place_id: string;
}

export type MappingSetKey =
  | "importOrders"
  | "importInvoices"
  | "importOrdersSales"
  | "importInvoicesSales";

export type MappingSet = Partial<
  Record<MappingSetKey, Array<{ [key: string]: string }>>
>;

export type MappingData = {
  success: boolean;
  mappings: MappingSet;
  error: string | null;
};
